// extracted by mini-css-extract-plugin
export default {"classification":"style_classification__Q0Cm1","configuration":"style_configuration__ruqXq","finish":"style_finish__1BTVQ","pricing":"style_pricing__0i0kS"};